<!-- Nombre de la seccion -->
<div class="row">
  <div class="col-12 text-center outline">
    <h2 class="separator-title {{menu.fontSections? menu.fontSections: menu.fontHeader}} p-1 justify-content-center" [ngStyle]="{'color': menu.colorText}" translate="no">
      <ng-container *ngIf="language === 'ES'">
        {{ separator.name | uppercase }}
      </ng-container>
      <ng-container *ngIf="language === 'EN'">
        {{ separator.name | uppercase }}
      </ng-container>
    </h2>
  </div>
</div>